import 'owl.carousel'

$(document).ready(function () {
    const baseUrl = 'https://www.turkeyadvisors.com'; // Replace with your actual base URL

    const renderer = new marked.Renderer();
    const linkRenderer = renderer.link;
    renderer.link = (href, title, text) => {
        const isExternal = href.startsWith('http') && !href.startsWith(baseUrl);
        let attrs = '';

        if (isExternal) {
            attrs = ' target="_blank" rel="noopener noreferrer"';
        }

        if (href.endsWith('{:.btn}')) {
            href = href.replace('{:.btn}', '');
            attrs += ' class="btn"';
        }

        return `<a href="${href}"${attrs}${title ? ` title="${title}"` : ''}>${text}</a>`;
    };
    $('#projects-carousel').owlCarousel({
        margin: 20,
        items: 3,
        dots: true,
        loop: true,
        nav: true,
        navText: [
            "<span class='long-arrow is-triangle arrow-bar is-left'></span>",
            "<span class='long-arrow is-triangle arrow-bar is-right'></span>"
        ],
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
            1200: {
                items: 4,
            }
        }
    });

    // Format project prices
    $('.project-price').each(function () {
        const price = $(this).data('price');
        $(this).text('$' + numberWithCommas(price));
    });
});

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
